import { TitleLinksElementSchema } from '../../schema/pageElements.val';
import BlankLink from '../BlankLink/BlankLink';

interface TitleLinksElementProps {
  title?: string;
  links: TitleLinksElementSchema['links'];
}

const TitleLinksElement = ({ title, links }: TitleLinksElementProps) => {
  return (
    <div className="w-full flex flex-col tablet:flex-row gap-24 laptop:px-128">
      {title && (
        <h3 className="font-respira text-respira-sm tablet:text-respira-md flex-1 max-w-920 block">
          {title}
        </h3>
      )}
      <div className="w-full flex flex-col gap-24 tablet:gap-24 laptop:px-128 items-start flex-1">
        {links.map((link, index) => {
          return (
            <BlankLink key={index} href={link.href} linkText={link.text} />
          );
        })}
      </div>
    </div>
  );
};

export default TitleLinksElement;
